<app-menubar></app-menubar>
<div class="flex-layout">
  <app-department-menu></app-department-menu>
  <app-posts style="width: 100%"></app-posts>
</div>
